import React, { useEffect, useState } from 'react';
import EntryRequestDetailView from '../Views/EntryRequestDetailView';
import { CustomModal, useCustomToast } from '../../../../components';
import { EntryRequest } from '../../types/entry-response';
import { useDownloadFilesEntries, useDownloadPdfEntries, useFetchEntryReqById } from '../../../../hooks/entryRequests';
import { useManageStatus, useUpdateEntryStatusDevuelto, useUpdateGestorEntryStatus } from '../../../../share';
import { useEntryGestorStatusolicitud } from '../../../../utils/validators/entry-request/entryGestorUpdateValidator';
import { EntryStatus } from '../../types';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import { authAtom } from '../../../../state';
import { useAtom } from 'jotai';

interface EntryRequestsDetailProps {
  isOpen: boolean;
  OnClose: () => void;
  data?: EntryRequest;
  isLoading: boolean;
  refetch?: () => void;
  isApproveRequest?: boolean;
  isModuleApproveRequest?: boolean;
  id?: string;
}

const EntryRequestDetailContainer: React.FC<EntryRequestsDetailProps> = ({
  isOpen,
  OnClose,
  isLoading,
  data,
  refetch,
  isApproveRequest,
  isModuleApproveRequest = false,
  id,
}) => {
  const [footerLeft, setFooterLeft] = React.useState<React.ReactNode>(null);
  const { mutateAsync } = useDownloadFilesEntries();
  const { mutateAsync: updateGestorStatus } = useUpdateGestorEntryStatus();
  const { mutateAsync: updateEntryStatusDevuelto } = useUpdateEntryStatusDevuelto();
  const { mutateAsync: downloadPDF } = useDownloadPdfEntries();
  const [authData] = useAtom(authAtom);

  const { data: entryPetition } = useManageStatus('EntryPetition');
  const { showToast } = useCustomToast()
  const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false)
  const [dataFirma, setDataFirma] = useState("");
  const [gestorMyRequest, setGestorMyRequest] = useState(false);
  const [files, setFiles] = useState([]);
  const [removeFiles, setRemoveFiles] = useState(false);
  const [dataEntry, setDataEntry] = useState<EntryRequest | undefined>();

  const { data: detailData, isPending: isLoadingData, refetch: refetchId } =
    useFetchEntryReqById(id);

  const onSaveGestor = async (values: any) => {
    const token = localStorage.getItem('auth')
    const tokenToJs = token ? JSON.parse(token).authorization.token : null

    const convertedFiles = files.map((item: any) => {
      if (item.url) {
        return {
          url: item.url
        }
      } else {
        return item.file
      }
    })
    const body = {
      status_id: values.status_id || 8,
      approved_by: Number(authData?.user.id),
      reason: values.reason,
      documents: convertedFiles,
    };

    try {
      await updateEntryStatusDevuelto({ body, token: tokenToJs, id: Number(dataEntry?.id) });
      if (refetch) {
        refetch();
        refetchId();
      }
      showToast('success', 'Solicitud actualizada')
    } catch (error: any) {

      if (error.response.statusText === "Forbidden") {
        showToast('error', 'No tienes Autorizacion')
      }
      OnClose();
    }
  };
  const onSave = async (values: any) => {
    const token = localStorage.getItem('auth')
    const tokenToJs = token ? JSON.parse(token).authorization.token : null

    entryPetition?.map((item: any) => {
      if (item.id === values.status_id) {
        if (item.name !== EntryStatus.DEVUELTO) {
          formikSolicitud.setFieldValue('reason', '')
        }
      }
    })
    const body = {
      status_id: values.status_id,
      reason: values.reason,
      signature_url: dataFirma,
    };


    try {
      await updateGestorStatus({ body, token: tokenToJs, id: Number(dataEntry?.id) });
      if (refetch) {
        refetch();
        refetchId();
      }
      showToast('success', 'Solicitud actualizada')
    } catch (error: any) {
      if (error.response.statusText === "Forbidden") {
        showToast('error', 'No tienes Autorizacion')
      }
      OnClose();
    }
  };
  const formikSolicitud = useEntryGestorStatusolicitud({ onSubmit: onSave })
  const validateAndOpenModal = async () => {
    const errors = await formikSolicitud.validateForm();
      formikSolicitud.setTouched(
        Object.keys(formikSolicitud.values).reduce(
          (acc: Record<string, boolean>, key) => {
            acc[key] = true;
            return acc;
          },
          {} as Record<string, boolean>
        )
      );
      if (Object.keys(errors).length === 0 || dataEntry?.status_id === 5) {
        setiIsOpenSaveChanges(true);
      }
  };

  const closeModalSaveChanges = () => {
    setiIsOpenSaveChanges(false);
    formikSolicitud.resetForm()
  }
  const handledDataFirma = (data: string) => {
    setDataFirma(data)
  }

  const confirmSaveChanges = async () => {
    try {
      if (gestorMyRequest) {
        await onSaveGestor(formikSolicitud.values); // Llama a onSave con los valores actuales
      } else {
        await onSave(formikSolicitud.values); // Llama a onSave con los valores actuales
      }

      onReset() // Cierra el modal después de guardar
    } catch (error) {
      showToast('error', 'Error al guardar:')
    }
  };
  const onReset = () => {
    closeModalSaveChanges();
    formikSolicitud.resetForm()
    setTimeout(() => {
      setFiles([])
      setRemoveFiles(true)
      OnClose();
    }, 100);

  };

  const handleGestorMyRequest = (opc: boolean, files: any) => {
    if(isApproveRequest || dataEntry?.status_id === 5){
      setGestorMyRequest(opc)
    } else{
      setGestorMyRequest(false)
    }
    
    setFiles(files)
  }

  useEffect(() => {
    if (detailData || data) {
      setDataEntry(detailData || data);
    }
  }, [detailData, data]);

  return (
    <CustomModal
      title={`Detalle solicitud de entrada - ${dataEntry?.ticket || '-'}`}
      open={isOpen}
      onCancel={onReset}
      width="95vw"
      isLoading={isLoading}
      footerLeft={footerLeft}
      onSave={validateAndOpenModal}
      labelCancel={(dataEntry?.can_manage && isApproveRequest) ? "Cancelar" : 'Finalizar'}
      labelSubmit={(dataEntry?.can_manage && isApproveRequest) || gestorMyRequest ? "Guardar" : ''}
      disabledBtn={!gestorMyRequest}
    >
      <EntryRequestDetailView
        detailData={dataEntry}
        setFooterLeft={setFooterLeft}
        onDocuments={mutateAsync}
        onDownloadPDf={downloadPDF}
        entryStates={entryPetition}
        formikSolicitud={formikSolicitud}
        handleGestorMyRequest={handleGestorMyRequest}
        removeFiles={removeFiles}
        isApproveRequest={isApproveRequest}
        isModuleApproveRequest={isModuleApproveRequest}
        authData={authData}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de gestionar esta solicitud de entrada?"
        textTwo="Una vez creado no podrá realizar cambios."
        open={isOpenSaveChanges}
        width={900}
        isLoadingSave={false}
        onClose={() => closeModalSaveChanges()}
        labelSubmit="Aceptar"
        onSave={() => confirmSaveChanges()}
        handledDataFirma={handledDataFirma} />
    </CustomModal>
  );
};

export default EntryRequestDetailContainer;
